<template>
    <div component="Popup" :open="visible" :class="{ isModal: isModal, wider: $route.meta.widerHeader }">
        <div class="panel">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import Navigation from '@/components/AppHeader/Navigation/Navigation.vue';
import Logo from '@/components/AppHeader/Logo.vue';

export default {
    name: 'Popup',

    props: {
        name: {
            type: String,
        },

        visible: {
            type: Boolean,
        },

        isModal: {
            type: Boolean,
            default: false,
        },
    },

    mounted() {
        this.$store.commit('addPopupObserver', this);
    },

    beforeDestroy() {
        this.$store.commit('removePopupObserver', this);
    },

    methods: {},

    computed: {
        getIsVisible() {
            return this.visible;
        },
    },

    components: {},
};
</script>
<style lang="less">
@import '~@variables';

[component='Popup'] {
    position: fixed;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 900;
    overflow: hidden;
    pointer-events: none;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    transition: 0.5s;
    max-width: 980px;
    margin: 0 auto;
    left: 50%;
    transform: translateX(-50%);
    padding: 50px 20px 20px;

    &.wider {
        @media (min-width: 768px) {
            max-width: 1200px;
        }
    }

    @media (min-width: 980px) {
        padding: 50px 30px 80px;

        @media (max-height: 599px) {
            padding-bottom: 30px;
        }
    }

    @media (min-width: 449px), (orientation: landscape) {
        justify-content: flex-end;
    }

    @media (max-height: 599px) {
        padding-right: 0;
        padding-top: 50px;
        overflow: visible;

        @media (orientation: landscape) {
            padding-top: 10px;
        }

        @media (max-width: 1024px) {
            max-width: none;
            padding-left: 30px;
            padding-right: 30px;
        }
    }

    &[open] {
        .panel {
            transform: translateY(0%);
        }

        &.isModal {
            pointer-events: all;
        }
    }

    .panel {
        transition: 0.5s;
        width: 100%;
        max-width: 296px;
        height: 100%;
        max-height: 650px;
        background: @white;
        .radiusBig;
        box-shadow: -10px 0 30px 5px rgba(0, 0, 0, 0.5);
        pointer-events: all;
        position: relative;
        transform: translateY(-250%);
        padding: 20px;

        @media (max-width: 449px) {
            max-width: 100%;
        }

        @media (max-height: 599px) {
            max-width: 317px;

            @media (max-width: 980px) {
                left: 0;
                right: 0;
                margin: auto;
            }
        }

        @media (max-width: 760px) {
            // padding-top: 10px;
            // padding-bottom: 10px;
            overflow: hidden;
        }

        @media (min-width: 768px) {
            transform: translateX(250%);
        }

        .close {
            position: absolute;
            right: 10px;
            top: 10px;
            cursor: pointer;
            z-index: 500;
        }
    }
}
</style>
